import { colors } from './styles'

interface AlertProps {
  readonly type: 'error' | 'success'
  readonly message: string
  readonly onDismiss?: () => void
}

export function Alert({ type, message, onDismiss }: AlertProps) {
  const isError = type === 'error'
  return (
    <div
      style={{
        padding: '0.75rem',
        background: isError ? colors.bgError : colors.bgSuccess,
        border: `1px solid ${isError ? colors.borderError : colors.borderSuccess}`,
        borderRadius: '6px',
        color: isError ? colors.danger : colors.success,
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <span>{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: '1.25rem' }}
        >
          x
        </button>
      )}
    </div>
  )
}
